import cx from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Tabs, Radio, ConfigProvider } from 'antd';

import { EMPLOYEE_EMPLOYMENT_PAGE } from "../schemas/employeeEmploymentSchema";
import EmployeeEmploymentInfo from "../pages/EmployeeEmploymentInfo";
import EmployeeEmploymentMovement from "../pages/EmployeeEmploymentMovement";
import EmployeeEmploymentOrganizationStructure from "../pages/EmployeeEmploymentOrganizationStructure";
import EmployeeEmploymentShift from "../pages/EmployeeEmploymentShift";
import EmployeeEmploymentSubordinates from "../pages/EmployeeEmploymentSubordinates";
import EmployeeEmploymentSupervisor from "../pages/EmployeeEmploymentSupervisor";
import styles from "../styles/Employee.module.css";
import menuStyles from "../styles/EmployeeMenu.module.css";
import { useSelector } from "react-redux";
function getItem(i18n_key, label, key, icon, children, type) {
  return {
    i18n_key,
    key,
    icon,
    children,
    label,
    type,
  };
}

const EMPLOYEE_INFO_MENU = [
  getItem(
    EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO,
    "Employment Info",
    EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO
    // <CopyOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_EMPLOYMENT_PAGE.SHIFT_INFO,
    "Shift Info",
    EMPLOYEE_EMPLOYMENT_PAGE.SHIFT_INFO
    // <CalendarOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_EMPLOYMENT_PAGE.CHAIN_OF_COMMAND,
    "Chain of command",
    EMPLOYEE_EMPLOYMENT_PAGE.CHAIN_OF_COMMAND,
    // <CopyOutlined style={{ color: "gray" }} />
    null,
    [
      getItem(
        EMPLOYEE_EMPLOYMENT_PAGE.SUBORDINATES,
        "Subordinates",
        EMPLOYEE_EMPLOYMENT_PAGE.SUBORDINATES
      ),
      getItem(
        EMPLOYEE_EMPLOYMENT_PAGE.SUPERVISOR,
        "Supervisor",
        EMPLOYEE_EMPLOYMENT_PAGE.SUPERVISOR
      ),
    ]
  ),
  getItem(
    EMPLOYEE_EMPLOYMENT_PAGE.ORGANIZATION_STRUCTURE,
    "Organization Structure",
    EMPLOYEE_EMPLOYMENT_PAGE.ORGANIZATION_STRUCTURE
    // <CopyOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_EMPLOYMENT_PAGE.MOVEMENT,
    "Movement",
    EMPLOYEE_EMPLOYMENT_PAGE.MOVEMENT
    // <CopyOutlined style={{ color: "gray" }} />
  ),
];

function EmployeeEmploymentMenu({ className = "", onChange = () => { } }) {
  const [selectedKeys, setSelectedKeys] = useState([
    EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO,
  ]);
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    onChange(key);
  };

  return (
    // <div className={cx("card-mini")}>
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemHoverColor: "var(--tab-color)",
            itemActiveColor: "var(--tab-color)"
          },
        },
      }}
    >
      <Tabs destroyInactiveTabPane={true} defaultActiveKey={selectedKeys} onChange={onMenuClick} tabBarStyle={{ justifyContent: 'space-between' }}>
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|EMPLOYMENT_INFO") &&
          <Tabs.TabPane tab={t('tab.menu.label.employment_info')} key={EMPLOYEE_EMPLOYMENT_PAGE.EMPLOYMENT_INFO}>
            <EmployeeEmploymentInfo />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|SHIFT_INFO") &&
          <Tabs.TabPane tab={t('tab.menu.label.shift-info')} key={[EMPLOYEE_EMPLOYMENT_PAGE.SHIFT_INFO]} >
            <EmployeeEmploymentShift />

          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|CHAIN_OF_COMMAND") &&
          <Tabs.TabPane tab={t('tab.menu.label.chain-of-command')} key={[EMPLOYEE_EMPLOYMENT_PAGE.CHAIN_OF_COMMAND]} >
            <Tabs defaultActiveKey={selectedKeys} onChange={onMenuClick} tabBarStyle={{ justifyContent: 'space-between' }}>
              <Tabs.TabPane tab={t('tab.menu.label.subordinates')} key={[EMPLOYEE_EMPLOYMENT_PAGE.SUBORDINATES]} >
                <EmployeeEmploymentSubordinates />
              </Tabs.TabPane>
              <Tabs.TabPane tab={t('tab.menu.label.supervisor')} key={[EMPLOYEE_EMPLOYMENT_PAGE.SUPERVISOR]} >
                <EmployeeEmploymentSupervisor />
              </Tabs.TabPane>
            </Tabs>
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|ORGANIZATION_STRUCTURE") &&
          <Tabs.TabPane tab={t('tab.menu.label.organization-structure')} key={[EMPLOYEE_EMPLOYMENT_PAGE.ORGANIZATION_STRUCTURE]} >
            <EmployeeEmploymentOrganizationStructure />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYMENT|MOVEMENT") &&
          <Tabs.TabPane tab={t('movement.header')} key={[EMPLOYEE_EMPLOYMENT_PAGE.MOVEMENT]} >
            <EmployeeEmploymentMovement />
          </Tabs.TabPane>
        }
      </Tabs>
    </ConfigProvider>
    // </div>
  );
}

export default EmployeeEmploymentMenu;
